import { createContext, useContext } from 'react'

export function useActionErrorHandler() {
  return useContext(ActionErrorHandlerContext).handleError
}

export const ActionErrorHandlerContext = createContext({
  handleError: (err) => {},
})
